// Story 10.5 — `<Can capability="..."><X/></Can>`. Si el user no tiene la
// capability, renderiza `fallback` (default null) en lugar de `children`.

import { useCan } from '@/hooks/use-can';
import type { Capability } from '@/lib/permissions';

interface Props {
  capability: Capability;
  /** Story 16.2 — si es una acción sobre un bot, sus capabilities deciden. */
  botId?: number;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function Can({ capability, botId, children, fallback = null }: Props): React.ReactElement {
  const allowed = useCan(capability, botId);
  return <>{allowed ? children : fallback}</>;
}
